import { AutoColumn } from 'components/Column'
import { AutoRow } from 'components/Row'
import { getDevice } from 'connection'
import { useMemo } from 'react'
import styled from 'styled-components/macro'
import { CloseIcon, ThemedText } from 'theme'
import { flexColumnNoWrap, gradientBorderSecondary } from 'theme/styles'
import { useConfig } from 'wagmi'

import { RECONNECT_KEY, useConnectModal, WalletAdapterData } from '../../connection/wallet-connect'
import { Portal } from '../../nft/components/common/Portal'
import IconButton from '../AccountDrawer/IconButton'
import Modal from '../Modal'
import Option from './Option'

const Wrapper = styled.div`
  position: relative;
  ${flexColumnNoWrap};
  background-color: ${({ theme }) => theme.backgroundModule};
  width: 100%;
  border-radius: 8px;
  padding: 14px 16px 16px;
  flex: 1;
  ${gradientBorderSecondary}
`

const OptionGrid = styled.div`
  display: grid;
  grid-gap: 2px;
  border-radius: 12px;
  overflow: hidden;
  ${({ theme }) => theme.deprecated_mediaWidth.deprecated_upToMedium`
    grid-template-columns: 1fr;
  `};
`

type Props = {
  wallets: WalletAdapterData[]
}

export default function ConnectWalletModal({ wallets }: Props) {
  const { isOpen, close } = useConnectModal()
  const device = useMemo(getDevice, [])
  const config = useConfig()

  const handleConnectSuccess = (walletId: string) => () => {
    config.storage?.setItem(RECONNECT_KEY, walletId)
    close()
  }

  return (
    <Portal>
      <Modal isOpen={isOpen}>
        <Wrapper>
          <AutoRow justify="space-between" width="100%" marginBottom="16px">
            <ThemedText.SubHeader fontWeight={500}>Connect a wallet</ThemedText.SubHeader>
            <IconButton Icon={CloseIcon} onClick={close} />
          </AutoRow>
          <AutoColumn gap="16px">
            <OptionGrid>
              {wallets.map((wallet) => {
                if ((wallet.isDesktopOnly && device.isMobile) || (wallet.isMobileOnly && !device.isMobile)) {
                  return null
                }

                return <Option key={wallet.walletId} onConnect={handleConnectSuccess(wallet.walletId)} {...wallet} />
              })}
            </OptionGrid>
          </AutoColumn>
        </Wrapper>
      </Modal>
    </Portal>
  )
}
